import React, { useCallback } from 'react'
import Loading from '../../components/common/Loading'
import { insuranceDetail } from '../../constant/path'
import { useRouter } from '../../utils/helper'
import { useGetEClaimHistoryById } from '../../services/e-claim/e-claim-query'
import { UserClaimDocumentList, FileType, ClaimDocumentTypes } from '../../services/e-claim/e-claim-types'
import { useMemo } from 'react'
import Headbar from '../../components/common/HeadBar'
import * as paths from '../../constant/path'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import config from '../../config'
import InsuranceForm from '../InsuranceDetail/InsuranceForm'
import colors from '../../constant/colors'
import { setInsuranceInfo } from '../../redux-store/insurance-reducer'
import InsuranceInfo from './InsuranceInfo'

export type InitialValueType = {
  name: string
  amountReceipt: number
  amountClaim: number
  receiptFile: string
  optionalFileUrl: string
  relativeTypeId: string
  receiptDate: string
  claimName: string
}

const InsuranceHistoryDetail = () => {
  const { query } = useRouter<{ id: number }>()
  const history = useHistory()
  const dispatch = useDispatch()
  const { data: insuranceItem, isLoading } = useGetEClaimHistoryById({ id: query.id })
  const {
    claim,
    userClaimAmount,
    userClaimAmountApprove,
    relativeId,
    slipDate,
  } = insuranceItem || {}

  const receiptFile = useMemo(() => {
    if (!insuranceItem?.documentTypes) return ''

    return insuranceItem?.documentTypes?.filter(item => item.name === FileType.ReceiptFile)[0]?.files?.length > 0
      ? insuranceItem.documentTypes.filter(item => item.name === FileType.ReceiptFile)[0].files[0].name
      : ''
  }, [insuranceItem?.documentTypes])

  const optionalFileUrl = useMemo(() => {
    if (!insuranceItem?.documentTypes) return ''

    return insuranceItem?.documentTypes?.filter(item => item.name === FileType.OptionalFileUrl)[0]?.files?.length > 0
      ? insuranceItem.documentTypes.filter(item => item.name === FileType.OptionalFileUrl)[0].files[0].name
      : ''
  }, [insuranceItem?.documentTypes])

  const initialValue = useMemo(() => {
    return {
      name: claim?.name || '',
      amountReceipt: userClaimAmount,
      amountClaim: userClaimAmountApprove,
      receiptFile,
      optionalFileUrl,
      relativeTypeId: relativeId ? relativeId.toString() : '',
      receiptDate: slipDate,
      claimName: claim?.name || '',
    }
  }, [claim, userClaimAmount, userClaimAmountApprove, relativeId, slipDate, receiptFile, optionalFileUrl])

  const disable = useMemo(() => {
    if (!insuranceItem?.isApproved && (insuranceItem?.isApproved !== null)) {
      return false
    } else {
      return true
    }
  }, [insuranceItem?.isApproved])

  const onCreateNewInsurance = useCallback(async () => {
    if (insuranceItem?.id === undefined) return

    dispatch(
      setInsuranceInfo({
        name: insuranceItem.claim.name || '',
        amountReceipt: insuranceItem.userClaimAmount,
        amountClaim: insuranceItem.userClaimAmountApprove,
        receiptFile,
        optionalFileUrl,
        relativeTypeId: insuranceItem.relativeId ? insuranceItem.relativeId.toString() : '',
        receiptDate: insuranceItem.slipDate,
        claimName: insuranceItem.claim.name || '',
        receiptNo: insuranceItem?.receiptNo || '',
        // remark: insuranceItem?.remark || '',
      }),
    )

    history.push(insuranceDetail({
      routeParam: {
        insuranceId: insuranceItem?.claimId
      },
      queryParam: {
        isCreateNew: 'true'
      }
    }))
  }, [insuranceItem, history, dispatch, receiptFile, optionalFileUrl])

  if (!insuranceItem || isLoading) return null

  return (
    <Loading loading={isLoading}>
      <div style={{ paddingTop: '24px' }}>
        <Headbar title={claim?.name || ''} backWard={paths.insuranceHistory()} titleColor={colors.BLACK} />
        <InsuranceInfo id={query.id} insuranceItem={insuranceItem} onCreateNewInsurance={onCreateNewInsurance} />
        <InsuranceForm
          insuranceItem={insuranceItem}
          insuranceId={insuranceItem.claimId}
          initialValues={initialValue}
          allpayStatus={disable}
          isHistory={true}
          editable={false}
        />
      </div>
    </Loading>
  )
}

export default InsuranceHistoryDetail